/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeaderFooterContent } from '../../models/header-footer-content';

export interface ApiMasterHeaderFooterIconGetHeaderFooterInfoGet$Params {
}

export function apiMasterHeaderFooterIconGetHeaderFooterInfoGet(http: HttpClient, rootUrl: string, params?: ApiMasterHeaderFooterIconGetHeaderFooterInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HeaderFooterContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterHeaderFooterIconGetHeaderFooterInfoGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeaderFooterContent>;
    })
  );
}

apiMasterHeaderFooterIconGetHeaderFooterInfoGet.PATH = '/api/Master/HeaderFooterIcon/GetHeaderFooterInfo';
